export default __webpack_public_path__ + "72fe214226da957fd2e1a5a4fa613b9c.woff";